import React from 'react'
import Skeleton from '@material-ui/lab/Skeleton';

const styles = {
  row:{
    backgroundColor:'#fff', 
    border:'0.6px solid #a3bbca',
    height:400,
    width:600,
    margin:'auto',
    borderRadius:10
  }
}

const InfoLoading = () => {
    return (
    <div>
        <br/><br/>
        <Skeleton style={styles.row} variant="text"  />
        <Skeleton style={styles.row} variant="text"  />
      
    </div>
    )
}

export default InfoLoading;